module.exports = __webpack_public_path__ + "media/static/icons/icon-river--green-afc3d5e05b7353f301e12fa73e26ae98.svg";